module.exports = {"success":true,"message":"string","code":"string"}


//////////////////
// WEBPACK FOOTER
// ./src/mocks/finishQuizMock.json
// module id = 472
// module chunks = 0